/**
 * Property map functionality.
 */

let mapHolder = null;

/**
 * Cache DOM elements.
 */
function cache() {
	return {
		mapLoadButton: document.getElementById( 'load-map' ),
		mapEmbed: document.getElementById( 'js-map-embed' ),
	};
}

/**
 * Load the map when button is clicked.
 *
 */
function loadMap() {
	const elements = cache();
	const { mapLoadButton, mapEmbed } = elements;

	if ( ! mapLoadButton || ! mapEmbed ) {
		return;
	}

	// Hide the load button
	mapLoadButton.classList.add( 'is-hidden' );
	mapHolder = mapLoadButton.parentNode;

	// Load map if Google Maps is available
	if ( typeof window.google !== 'undefined' && window.google.maps ) {
		mapHolder.classList.add( 'is-loading' );
		createMap( mapEmbed );
	} else {
		loadError( mapEmbed );
	}
}

/**
 * Show error message if Google Maps is not available.
 *
 * @param {Element} mapElem - Map container element
 */
function loadError( mapElem ) {
	const message = document.createElement( 'div' );
	message.className = 'map-error-message';
	message.innerHTML = '<p>Could not load map. Please check your internet connection.</p>';
	mapElem.appendChild( message );
	mapElem.classList.remove( 'is-hidden' );
}

/**
 * Create new Google Map instance.
 *
 * @param {Element} mapElem - Map DOM element
 */
function createMap( mapElem ) {
	const markers = mapElem.querySelectorAll( '.marker' );

	if ( markers.length === 0 ) {
		loadError( mapElem );
		return;
	}

	const mapOptions = {
		zoom: 15,
		maxZoom: 18,
		mapTypeId: window.google.maps.MapTypeId.ROADMAP,
		styles: [
			{
				featureType: 'poi',
				elementType: 'labels',
				stylers: [ { visibility: 'off' } ],
			},
		],
	};

	const map = new window.google.maps.Map( mapElem, mapOptions );
	map.markers = [];

	// Add markers to the map
	markers.forEach( ( markerElement ) => {
		addMapMarker( markerElement, map );
	} );

	// Center the map based on markers
	centerMap( map );

	// Show map and remove loading state
	mapElem.classList.remove( 'is-hidden' );
	if ( mapHolder ) {
		mapHolder.classList.remove( 'is-loading' );
		mapHolder = null;
	}
}

/**
 * Add marker to the Google Map.
 *
 * @param {Element} markerElem - Marker element with data attributes
 * @param {Object}  gmap       - Google Map object
 */
function addMapMarker( markerElem, gmap ) {
	const lat = parseFloat( markerElem.dataset.lat );
	const lng = parseFloat( markerElem.dataset.lng );

	if ( isNaN( lat ) || isNaN( lng ) ) {
		return;
	}

	const position = new window.google.maps.LatLng( lat, lng );

	const marker = new window.google.maps.Marker( {
		position,
		map: gmap,
		title: 'Property Location',
	} );

	gmap.markers.push( marker );
}

/**
 * Center the map to show all markers.
 *
 * @param {Object} gmap - Google Map object
 */
function centerMap( gmap ) {
	if ( gmap.markers.length === 0 ) {
		return;
	}

	if ( gmap.markers.length === 1 ) {
		// Single marker - center on it
		gmap.setCenter( gmap.markers[ 0 ].getPosition() );
		gmap.setZoom( 15 );
	} else {
		// Multiple markers - fit bounds
		const bounds = new window.google.maps.LatLngBounds();

		gmap.markers.forEach( ( marker ) => {
			bounds.extend( marker.getPosition() );
		} );

		gmap.fitBounds( bounds );
	}
}

/**
 * Initialize property map functionality.
 */
function propertyMapInit() {
	const elements = cache();

	if ( elements.mapLoadButton ) {
		elements.mapLoadButton.addEventListener( 'click', loadMap );
	}
}

// Initialize when DOM is ready
if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', propertyMapInit );
} else {
	propertyMapInit();
}

export { propertyMapInit };
